module.exports = __webpack_public_path__ + "img/drink_coupon_chiba.9625bef9.png";